// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiClickhouse as RawSiClickhouse } from "react-icons/si";
export const SiClickhouse = /* @__PURE__ */ createIcon(RawSiClickhouse, "SiClickhouse", 0);
